// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wH12vnciOe6g5ZtJok8r {
  background-color: var(--md-grey-color);
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: calc(100vh - var(--global-nav-height));
  padding-bottom: 1rem;
  padding-top: 2rem;
}

.HYwp9JE40RaVxFECAsDJ {
  align-content: center;
  max-width: var(--grid-max-width);
  padding-inline: var(--grid-gutter);
  margin-inline: auto;
  min-height: calc(90vh - var(--global-nav-height));
}

.HYwp9JE40RaVxFECAsDJ p {
  color: var(--white-color);
  text-wrap: balance;
  margin-top: 0;
  margin-bottom: 1.5em;
  text-align: center;
  font-size: var(--step-0);
}

.HYwp9JE40RaVxFECAsDJ h2 {
  color: var(--white-color);
  text-align: center;
  font-size: var(--step-3);
  margin-top: 0;
  margin-bottom: 1.5em;
}

.sng488SOnzoYoVGu4GId {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: var(--space-s);
}

.SVR6OzLC42pqoVUMM9yq {
  width: 100%;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  margin-top: var(--space-xl);
  justify-content: center;
  align-content: center;
  gap: var(--space-s-m);
}

.IhwdwuQRLfS9RFtotSdw {
  font-size: var(--step-5);
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0 0.125em 0.25em rgba(0, 0, 0, 0.6);
  text-align: center;
  background: none;
  background-color: transparent;
  border: none;
  text-decoration: none;
  transition: var(--global-nav-transition);
  cursor: pointer;
  z-index: 200;
}

.IhwdwuQRLfS9RFtotSdw:hover,
.IhwdwuQRLfS9RFtotSdw:focus {
  color: rgba(255, 255, 255, 1);
  text-shadow: 0 0.125em 0.25em rgba(0, 0, 0, 0.4);
}

.IhwdwuQRLfS9RFtotSdw:active {
  color: rgba(255, 255, 255, 0.8);
  text-shadow: 0 0 0.25em rgba(0, 0, 0, 0.3);
}

.NdoLrbUNMMH7TfMTRQ2D {
  display: flex;
  flex-direction: column;
  width: min-content;
  padding-left: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/HomePage/components/TrendingSection.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kDAAkD;EAClD,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,kCAAkC;EAClC,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,qBAAqB;EACrB,wCAAwC;EACxC,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,6BAA6B;EAC7B,gDAAgD;AAClD;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".trendingTopics {\n  background-color: var(--md-grey-color);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: calc(100vh - var(--global-nav-height));\n  padding-bottom: 1rem;\n  padding-top: 2rem;\n}\n\n.sectionContent {\n  align-content: center;\n  max-width: var(--grid-max-width);\n  padding-inline: var(--grid-gutter);\n  margin-inline: auto;\n  min-height: calc(90vh - var(--global-nav-height));\n}\n\n.sectionContent p {\n  color: var(--white-color);\n  text-wrap: balance;\n  margin-top: 0;\n  margin-bottom: 1.5em;\n  text-align: center;\n  font-size: var(--step-0);\n}\n\n.sectionContent h2 {\n  color: var(--white-color);\n  text-align: center;\n  font-size: var(--step-3);\n  margin-top: 0;\n  margin-bottom: 1.5em;\n}\n\n.pillLinkList {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  gap: var(--space-s);\n}\n\n.btnGroup {\n  width: 100%;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: var(--space-xl);\n  justify-content: center;\n  align-content: center;\n  gap: var(--space-s-m);\n}\n\n.pageDownBtn {\n  font-size: var(--step-5);\n  color: rgba(255, 255, 255, 0.9);\n  text-shadow: 0 0.125em 0.25em rgba(0, 0, 0, 0.6);\n  text-align: center;\n  background: none;\n  background-color: transparent;\n  border: none;\n  text-decoration: none;\n  transition: var(--global-nav-transition);\n  cursor: pointer;\n  z-index: 200;\n}\n\n.pageDownBtn:hover,\n.pageDownBtn:focus {\n  color: rgba(255, 255, 255, 1);\n  text-shadow: 0 0.125em 0.25em rgba(0, 0, 0, 0.4);\n}\n\n.pageDownBtn:active {\n  color: rgba(255, 255, 255, 0.8);\n  text-shadow: 0 0 0.25em rgba(0, 0, 0, 0.3);\n}\n\n.pageDownBtnWrapper {\n  display: flex;\n  flex-direction: column;\n  width: min-content;\n  padding-left: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trendingTopics": `wH12vnciOe6g5ZtJok8r`,
	"sectionContent": `HYwp9JE40RaVxFECAsDJ`,
	"pillLinkList": `sng488SOnzoYoVGu4GId`,
	"btnGroup": `SVR6OzLC42pqoVUMM9yq`,
	"pageDownBtn": `IhwdwuQRLfS9RFtotSdw`,
	"pageDownBtnWrapper": `NdoLrbUNMMH7TfMTRQ2D`
};
export default ___CSS_LOADER_EXPORT___;
